import style from './EnterAmountPage.css';
import { useEffect, useRef, useState } from 'preact/hooks';
import AppBar from '../../components/shared/AppBar/AppBar';
import NavigationUtils from '../../utils/navigation.utils';
import EnterAmountPageSkeleton from '../../components/PeerToPeer/EnterAmountPageSkeleton/EnterAmountPageSkeleton';
import EnterAmountPageView from '../../components/PeerToPeer/EnterAmountPageView/EnterAmountPageView';
import CommissionService from '../../services/commission.service';
import { EnterAmountProvider, EnterAmountType } from './EnterAmountProvider';
import useTranslation from '../../localization/i18n.context';
import EnterAmountParser, { EnterAmountParams } from './EnterAmountParser';
import useConfig from '../../config/config.context';
import { OutlineOnboardingInterceptor } from '../OutlineOnboarding/OutlineOnboardingInterceptor';
import { OutlineOnboardingType } from '../OutlineOnboarding/OutlineOnboardingProvider';

export default function EnterAmountPage() {
  const currentParams = new URLSearchParams(window.location.search);
  const type = currentParams.get(EnterAmountParams.TYPE) || EnterAmountType.P2P;
  const { config } = useConfig();
  const { t, getOrganization } = useTranslation();
  const backRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState({});
  const providerData = EnterAmountProvider(t, type?.toUpperCase());
  const organizationCode = currentParams.get(
    EnterAmountParams.ORGANIZATION_CODE,
  );

  useEffect(() => {
    const destination = `${NavigationUtils.Routes.ENTER_AMOUNT}${
      window.location.search
    }&source=${NavigationUtils.getSource()}`;

    //if there is an Outline Onboarding to show, the Enter amount flow is paused until OO has been finished
    if (type?.toUpperCase() === EnterAmountType.MICROLOAN) {
      if (
        OutlineOnboardingInterceptor.interceptURL(
          OutlineOnboardingType.MICROLOAN,
          destination,
          config,
        )
      ) {
        return;
      }
    }

    getData();
  }, []);

  const getData = () => {
    const params = EnterAmountParser.parseURLParams(currentParams);
    CommissionService.get(params)
      .then(response => {
        const enterAmountData = EnterAmountParser.parseResponse(
          t,
          currentParams,
          type,
          response.data,
          getOrganization,
        );
        setData(enterAmountData);
        setIsLoading(false);
      })
      .catch(err => {
        console.error(`Something went wrong`, err);
        NavigationUtils.navigate(NavigationUtils.Routes.TRY_AGAIN);
      });
  };

  return (
    <>
      <AppBar
        onBackClick={() => {
          NavigationUtils.back();
        }}
        onCloseClick={() => {
          NavigationUtils.endFlow();
        }}
        title={providerData?.title}
        backRef={backRef}
        className="fixed-bar"
      />
      <div className={style.container}>
        {isLoading ? (
          <EnterAmountPageSkeleton />
        ) : (
          <EnterAmountPageView
            organizationCode={organizationCode}
            commission={data.commission}
            sender={data.sender}
            receiver={data.receiver}
            defaultAmount={data?.defaultAmount}
            params={data?.params}
            service={type}
            availableAmounts={data?.amounts}
          />
        )}
      </div>
    </>
  );
}
